<template>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" :hide-required-asterisk="true" class="demo-ruleForm" style="margin-top: 30px">
        <el-form-item label="行业分类" prop="goods_category_id">
            <el-cascader filterable disabled v-model="ruleForm.goods_category_id" :props="keyObj" style="width: 312px"
                         :options="goodClassList" clearable placeholder="请选择行业分类"></el-cascader>
            <el-button type="primary" style="margin-left: 10px" @click="categoryDialog = true">选择行业分类</el-button>
        </el-form-item>
      <el-dialog title="选择类目" :visible.sync="categoryDialog" @open="openDialog" width="650px" custom-class="green-dialog add-task-dialog"
      :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false">
        <i class="iconfont close-icon"  @click="closeDialog">&#xe668;</i>
        <el-cascader-panel class="create-practical-panel" v-model="ruleForm.goods_category_id" :props="keyObj" :options="goodClassList" clearable></el-cascader-panel>
        <div class="dialog-footer" style="text-align: center;margin-top: 26px">
          <el-button @click="closeDialog">取消</el-button>
          <el-button type="primary" @click="changeClassTwo">确 定</el-button>
        </div>
      </el-dialog>
        <el-form-item label="客服名称" prop="kefu_id">
            <el-select filterable v-model="ruleForm.kefu_id" placeholder="请选择客服服务" style="width: 360px" @change="changeCustomer" :disabled="customerList.length === 0">
                <el-option v-for="(item, index) in customerList" :key="`customerList_${index}`" :label="item.name" :value="item.kefu_id"></el-option>
            </el-select>
            <el-input v-model="ruleForm.score" style="width: 80px; margin-left: 10px" disabled></el-input>
            <span style="font-size: 16px; color: #333; margin-left: 10px">分</span>
        </el-form-item>
        <el-form-item style="text-align: center; margin-top: 40px">
            <el-button type="primary" @click="submitForm('ruleForm')">保存</el-button>
            <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
    import { kefuListKefuData, operationProblemSaveCustomerService, adminGoodGetCategory } from '@/utils/apis.js'
    export default {
        props: {
            practiceForm: {
                type: Object,
                default:() => {}
            }
        },
        data() {
            return {
                ruleForm: {
                    goods_category_id: null,
                    kefu_id: null,
                    score: null,
                },
                lastCategoryId:null,
                rules: {
                    // goods_category_id: [
                    //     { required: true, message: '请选择行业分类', trigger: 'change' }
                    // ],
                    // kefu_id: [
                    //     { required: true, message: '请选择客服名称', trigger: 'change' }
                    // ],
                },
                customerList: [],
                keyObj: {
                    label: 'name',
                    value: 'id',
                    children: 'children'
                },
                goodClassList: [], // 商品类目
                categoryDialog:false,
            }
        },
        mounted() {
          this.getGoodsCategory();
        },
        methods: {
            // 获取编辑数据
            getEditDetail(obj){
              this.ruleForm.goods_category_id = obj.goods_category_id;
              this.ruleForm.kefu_id = obj.kefu_id;
              this.ruleForm.score = obj.score;
              this.getCustomer();
            },
            // 获取行业分类
            getGoodsCategory() {
                adminGoodGetCategory().then((res) => {
                    this.goodClassList = res.data
                })
            },
            // 打开分类
            openDialog(){
              this.lastCategoryId = JSON.parse(JSON.stringify(this.ruleForm.goods_category_id));
            },
            // 选择商品类目筛选客服
            changeClassTwo() {
                this.ruleForm.kefu_id = null
                this.customerList = []
                this.ruleForm.score = null
                this.getCustomer();
                this.categoryDialog = false;
            },
            // 取消
            closeDialog(){
              this.ruleForm.goods_category_id = JSON.parse(JSON.stringify(this.lastCategoryId))
              this.categoryDialog = false;
            },
            // 获取客服列表
            getCustomer() {
                let params = {
                    category_id: this.ruleForm.goods_category_id[this.ruleForm.goods_category_id.length - 1],
                }
                kefuListKefuData(params).then((res) => {
                    this.customerList = res.data
                })
            },
            // 修改客服选择
            changeCustomer(val) {
                let tmp = this.customerList.find(item => {
                    return Number(val) === Number(item.kefu_id)
                })
                if (tmp) {
                    this.ruleForm.score = tmp.score
                }
            },
            // 保存试题
            submitForm(formName) {
                if (!this.practiceForm.name) {
                    return this.$message.warning('请填写名称！');
                }
                if (!this.practiceForm.time) {
                    return this.$message.warning('请输入考核时间')
                }
                if (this.practiceForm.classValue.length === 0) {
                    return this.$message.warning('请选择分类！');
                }
                if (this.practiceForm.taskList.length === 0) {
                    return this.$message.warning('请添加任务目标！');
                }
                if (!this.practiceForm.taskBackground) {
                    return this.$message.warning('请填写任务背景！');
                }
                if (!this.practiceForm.taskAnalysis) {
                    return this.$message.warning('请填写任务分析！');
                }
                if (!this.practiceForm.taskOperation) {
                    return this.$message.warning('请填写任务操作！');
                }
                if (this.practiceForm.scoreList.length === 0) {
                    return this.$message.warning('请添加评分标准！');
                }
                if (!this.ruleForm.goods_category_id) {
                    return this.$message.warning('请选择行业分类！');
                }
                if (!this.ruleForm.kefu_id) {
                    return this.$message.warning('请选择客服名称！');
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        let params = {
                            op_name: this.practiceForm.name,
                            // exam_module_id: this.practiceForm.module_level_three_value,
                            category_id: this.practiceForm.classValue[this.practiceForm.classValue.length - 1],
                            assess_time: this.practiceForm.time,
                            task_goal: this.practiceForm.taskList,
                            task_background: this.practiceForm.taskBackground,
                            task_analysis: this.practiceForm.taskAnalysis,
                            task_operation: this.practiceForm.taskOperation,
                            scoring_criteria: this.practiceForm.scoreList,
                            goods_category_id: this.ruleForm.goods_category_id[this.ruleForm.goods_category_id.length - 1],
                            kefu_id: this.ruleForm.kefu_id,
                            score: this.ruleForm.score,
                        }
                        if(this.$route.query.id){
                          params.id = this.$route.query.id
                        }
                        operationProblemSaveCustomerService(params).then((res) => {
                            this.$message.success(res.msg)
                            this.$router.push('/practice/index')
                        })
                    } else {
                        return false;
                    }
                });
            },
            // 重置试题
            resetForm(formName) {
                this.$router.go(-1)
                this.$refs[formName].resetFields();
                // this.$emit('update:practiceForm', {
                //     ...this.practiceForm,
                //     name: '',
                //     time: '',
                //     module_level_one_value: '',
                //     module_level_tow_value: '',
                //     module_level_three_value: '',
                //     classValue: [],
                //     taskList: [],
                //     taskBackground: '',
                //     taskAnalysis: '',
                //     taskOperation: '',
                //     scoreList: [],
                // })
            }
        }
    }
</script>

<style scoped lang="scss">
    .demo-ruleForm {
        ::v-deep {
            .el-form-item__label {
                color: #333;
                font-size: 16px;
            }
        }
    }
    .add-task-dialog{
      position: relative;
      .close-icon{
        position: absolute;
        right: 26px;
        top: 18px;
        font-size: 16px;
        color: #333333;
        cursor: pointer;
      }
    }
    .create-practical-panel{
      height: 286px;
      ::v-deep .el-cascader-menu__wrap{
        height: 100%;
      }
    }
</style>